import React from "react";
import Form from "react-bootstrap/Form";
import { Col, Row } from "react-bootstrap";
import classNames from "classnames";
import ClockIcon from "./svg/ClockIcon";
import FloatingLabel from "react-bootstrap/FloatingLabel";

export default function InputTime({
  children,
  popoverText,
  error,
  valid,
  ...params
}) {
  return (
    <>
      <Row className="align-items-center flex-nowrap position-relative mb-3 input_time w-100">
        <Col xs={12} className="position-relative">
          <FloatingLabel label={params?.placeholder}>
            <Form.Control
              {...params}
              type="time"
              className={classNames(
                "pe-5 pe-md-2 position-relative pb-2 pt-4",
                {
                  "border-danger": error,
                  "border-success": valid,
                }
              )}
            />
            <ClockIcon className="position-absolute top-50 translate-middle-y r-20" />
          </FloatingLabel>
          {children}
        </Col>
      </Row>
    </>
  );
}
